import { TextField } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { styled } from "@mui/material/styles";
import { BaseCard, MediaQuerys } from "../../styles/GlobalStyle";

const { mobile } = MediaQuerys;

export const SectionPageTitle = styled("section")(() => ({
  display: "flex",
  width: "100%",
}));

export const Spacer = styled("div")(() => ({
  display: "flex",
  flex: 1,
}));

export const Input = styled(TextField)(() => {
  const { colors } = useColors();  
  return {
    width: '100%',
    '.MuiInputBase-root': {
        background: colors.white,
        borderRadius: 6,
        fontSize: 13,
        [mobile]: {
          fontSize: 12
        }
    }
  }
})

export const CardContainer = styled(BaseCard)(() => {
  return {
    marginTop: '10px',
    padding: '1.5rem 2rem'
  }
})